import { useCallback, useEffect, useState } from "react";
import { apiService } from "constants/axiosInstance";

export const useGetLibraryList = (shouldCall) => {
  const [libraryList, setLibraryList] = useState([]);

  const getListLibraryList = useCallback(async () => {
    try {
      const config = {
        url: "/project-field/library",
        method: "GET",
      };
      const result = await apiService(config);
      return result.data;
    } catch (error) {
      throw error;
    }
  }, []);

  useEffect(() => {
    if (shouldCall && libraryList?.length === 0) {
      getListLibraryList().then(res => {
        if (res?.state) {
          setLibraryList(res?.data);
        } else {
          setLibraryList([]);
        }
      }).catch(err => {
        console.log("err >>> ", err);
        setLibraryList([]);
      });
    }
  }, [shouldCall]);

  return libraryList;
};

export const createColFromLibrary = async (body) => {
  try {
    const config = {
      url: "/project-field/copy",
      method: "POST",
      data: body
    };
    const result = await apiService(config);
    return result.data;
  } catch (error) {
    return false;
  }
};